import React from 'react';

import Head from 'next/head';

import AccessibleContent from '@/components/AccessibleContent';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Accessible = () => {
  return (
    <div className="page-wrapper">
      <Head>
        <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
        <title>Find Home Service Pros Near You</title>

        <link rel="canonical" href="https://callapro.com" />
      </Head>
      <Header />
      <AccessibleContent />
      <Footer />
    </div>
  );
};

export default Accessible;
